import { Card } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import Chevron_bottom_rv from '../../../../assets/images/icons/chevron_bottom_rv.png';
import IconShareTop from '../../../../assets/images/icons/share_rv.png';
import { BaseURL } from '../../../../base/env';
import { TComma } from '../../../../base/utils';
import { Button, Uniter } from '../../../../helbest';
import styles from './DetailModal.module.css';

// ============================================================
// اعتبارسنجی آیتم‌ها (حالت 2)
// ============================================================
const isValidItem = (item) => {
  if (!item || typeof item !== 'object') return false;

  const validKeys = ['section', 'key', 'value', 'price', 'discount'];
  const itemKeys = Object.keys(item);

  if (itemKeys.some((k) => !validKeys.includes(k))) return false;
  if (!item.section) return false;
  if (!item.key && !item.value) return false;

  return true;
};

// ============================================================
// کامپوننت Positions برای رندر key، value و price
// ============================================================
const Positions = (key, value, price) => {
  if (!key && !value && !price) return null;

  const commonStyles = {
    wrapper: {
      width: '100%',
      fontSize: '12px',
      display: 'flex',
      flexDirection: 'column',
      gap: '6px'
    },
    row: {
      display: 'flex',
      width: '100%',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: '8px',
      flexWrap: 'wrap'
    },
    key: {
      margin: 0,
      fontWeight: 'bold',
      fontSize: '12px',
      flexGrow: 1,
      overflowWrap: 'break-word',
      wordBreak: 'break-word'
    },
    value: {
      margin: 0,
      textAlign: 'left',
      minWidth: 0,
      whiteSpace: 'normal',
      fontSize: '12px',
      overflowWrap: 'break-word',
      wordBreak: 'break-word'
    },
    price: {
      margin: 0,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      color: '#ee2a7b',
      fontSize: '12px'
    },
    multilineValue: {
      margin: 0,
      fontWeight: 'normal',
      fontSize: '12px',
      flexGrow: 1,
      overflowWrap: 'break-word',
      wordBreak: 'break-word'
    }
  };

  let direction = 'left';
  let formattedValue = value || '';

  if (typeof formattedValue === 'string') {
    if (formattedValue.includes('<r>')) {
      direction = 'right';
      formattedValue = formattedValue.replace(/<r>/gi, '');
    } else if (formattedValue.includes('<l>')) {
      formattedValue = formattedValue.replace(/<l>/gi, '');
    }
  }

  const parseValue = (text) => {
    if (typeof text !== 'string') return text;

    // جدا کردن بر اساس <br>
    const lines = text.split(/<br\s*\/?>/gi);

    return lines.map((line, i) => {
      // جدا کردن <bold> و <a>
      const parts = line.split(/(<bold>.*?<\/bold>|<a\s+href=".*?">.*?<\/a>)/gi);

      return (
        <React.Fragment key={i}>
          {parts.map((part, j) => {
            if (part.match(/^<bold>.*<\/bold>$/i)) {
              const innerText = part.replace(/<\/?bold>/gi, '');
              return (
                <strong key={j} style={{ fontWeight: 'bold' }}>
                  {innerText}
                </strong>
              );
            }
            if (part.match(/^<a\s+href=".*?">.*<\/a>$/i)) {
              const hrefMatch = part.match(/href="(.*?)"/i);
              const href = hrefMatch ? hrefMatch[1] : '#';

              const textMatch = part.match(/<a\s+href=".*?">(.*)<\/a>/i);
              const linkText = textMatch ? textMatch[1] : href;

              return (
                <a
                  key={j}
                  href={href}
                  rel="noopener noreferrer"
                  style={{ color: '#1890ff', textDecoration: 'underline' }}
                  target="_blank">
                  {linkText}
                </a>
              );
            }
            return <React.Fragment key={j}>{part}</React.Fragment>;
          })}
          {i < lines.length - 1 ? <br /> : null}
        </React.Fragment>
      );
    });
  };

  const parsedValue = parseValue(formattedValue);
  const isMultilineText = (text) =>
    typeof text === 'string' && (text.includes('<br') || text.includes('\n') || text.length > 30);

  // =====================================================
  // ⭐ CASE 1 — (NO KEY) value + price
  // =====================================================

  if (!key && value && price) {
    const keyIsMultiline = isMultilineText(value);

    if (keyIsMultiline) {
      return (
        <div style={commonStyles.wrapper}>
          <p style={{ ...commonStyles.multilineValue, textAlign: 'justify' }}>{value}</p>
          <div style={{ marginTop: '4px' }}>
            <p style={{ ...commonStyles.price }}>{price}</p>
          </div>
        </div>
      );
    } else {
    }
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <p style={{ ...commonStyles.multilineValue, textAlign: 'justify' }}>{value}</p>
        <p style={{ ...commonStyles.price }}>{price}</p>
      </div>
    );
  }

  // =====================================================
  // ⭐ CASE 2 — key + price (NO VALUE)
  // =====================================================
  if (key && !value && price) {
    const keyIsMultiline = isMultilineText(key);

    if (keyIsMultiline) {
      return (
        <div style={commonStyles.wrapper}>
          <p style={{ ...commonStyles.key, textAlign: 'justify' }}>{key}</p>

          <div style={{ marginTop: '4px' }}>
            <p style={{ ...commonStyles.price }}>{price}</p>
          </div>
        </div>
      );
    } else {
    }
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <p style={{ ...commonStyles.key, textAlign: 'justify' }}>{key}</p>

        <p style={{ ...commonStyles.price }}>{price}</p>
      </div>
    );
  }

  // =====================================================
  // 🔥 MAIN OUTPUT
  // =====================================================
  return (
    <div style={commonStyles.wrapper}>
      {direction === 'right' && key && value ? (
        <div style={{ textAlign: 'right' }}>
          <p style={{ ...commonStyles.key, textAlign: 'justify' }}>{key}</p>
          <p style={{ ...commonStyles.value, textAlign: 'justify' }}>{parsedValue}</p>
        </div>
      ) : null}

      {/* KEY + VALUE */}
      {key && value && direction !== 'right' ? (
        <div style={commonStyles.row}>
          <p style={{ ...commonStyles.key, textAlign: 'justify' }}>{key}</p>
          <p style={{ ...commonStyles.value, textAlign: 'justify' }}>{parsedValue}</p>
        </div>
      ) : null}

      {/* ONLY KEY */}
      {key && !value && !price ? (
        <p style={{ ...commonStyles.value, textAlign: 'justify' }}>{key}</p>
      ) : null}

      {/* ONLY VALUE */}
      {!key && value && !price ? (
        <p style={{ ...commonStyles.value, textAlign: 'justify' }}>{parsedValue}</p>
      ) : null}

      {/* ONLY PRICE (when key/value not special-cased) */}
      {price && key && value ? <p style={commonStyles.price}>{price}</p> : null}
    </div>
  );
};

const DetailModal = ({
  store,
  setShareModal,
  showShare,
  isModalVisible,
  HideModal,
  data,
  add_to_cart
}) => {
  const [modal_visibility, set_modal_visibility] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const product_detail = [];
  const pricing_detail = [];
  const description = [];

  data?.details?.filter(isValidItem)?.forEach((item) => {
    if (item.section === 'product_detail') {
      product_detail.push(item);
    } else if (item.section === 'pricing_detail') {
      pricing_detail.push(item);
    } else if (item.section === 'description') {
      description.push(item);
    }
  });

  useEffect(() => {
    if (isModalVisible) {
      document.body.style.overflow = 'hidden';
      set_modal_visibility(true);
    } else {
      setTimeout(() => {
        document.body.style.overflow = 'auto';
        set_modal_visibility(false);
      }, 300);
    }

    if (isModalVisible) {
      history.push(`${location.pathname}${location.search}`);
      const popHandler = (e) => {
        e.preventDefault();
        HideModal();
      };
      window.addEventListener('popstate', popHandler);

      return () => {
        window.removeEventListener('popstate', popHandler);
        document.body.style.overflow = 'auto';
      };
    }
    return () => {};
  }, [isModalVisible]); // eslint-disable-line

  const detailItemsValue = (items) => (
    <div>
      {items?.map((item, index) => {
        const priceStr = item?.price?.toString() || '';
        const discountStr = item?.discount?.toString() || '';
        const hasDiscount = discountStr.length > 0;
        const isEmptyPrice =
          item.key && item.value && priceStr.length === 0 && discountStr.length === 0;

        const price_detail = (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: '10px',
              margin: 0,
              fontVariantNumeric: 'tabular-nums'
            }}>
            <span
              style={{
                display: 'inline-block',
                width: '80px',
                textAlign: 'left',
                textDecoration: hasDiscount ? 'line-through' : 'none',
                color: '#ee2a7b',
                fontVariantNumeric: 'tabular-nums',
                marginTop: '6px'
              }}>
              {priceStr.length > 0 ? TComma(Math.round(item?.price)) : ''}
            </span>

            <span
              style={{
                display: 'inline-block',
                width: '80px',
                textAlign: 'left',
                color: '#ee2a7b',
                fontVariantNumeric: 'tabular-nums'
              }}>
              {hasDiscount ? (
                priceStr === discountStr ? (
                  'رایگان'
                ) : (
                  <>
                    {priceStr.length > 0 && discountStr.length > 0 ? (
                      <p>
                        <Uniter unit="تومان">{Number(priceStr) - Number(discountStr)}</Uniter>
                      </p>
                    ) : null}
                  </>
                )
              ) : (
                ''
              )}
            </span>
          </div>
        );

        return (
          <div key={index}>
            {Positions(item.key, item.value, price_detail)}

            {index !== items.length - 1 ? (
              <hr
                style={{
                  width: '100%',
                  height: '0.5px',
                  border: 'none',
                  backgroundColor: 'rgb(207 207 207)',
                  margin: isEmptyPrice ? '2px auto 10px auto' : '10px auto'
                }}
              />
            ) : null}
          </div>
        );
      })}
    </div>
  );

  return (
    <div className="detail-modal" style={{ top: isModalVisible ? '0' : '100%' }}>
      {modal_visibility ? (
        <div className="close-parent-detail">
          <div className="detail-header">
            <div className="icon-parent" onClick={HideModal}>
              <img alt="close" src={Chevron_bottom_rv} />
            </div>
            <div>جزئیات کالا</div>
            {showShare ? (
              <div className="icon-parent" onClick={() => setShareModal(true)}>
                <img alt="اشتراک گذاری" src={IconShareTop} />
              </div>
            ) : (
              <div className="icon-parent" />
            )}
          </div>

          <div className="detail-container">
            <div className={styles.ProductDetailImageContainer}>
              <div className="product-detail-p-img">
                <img
                  alt={data.id}
                  className="product-detail-img"
                  loading="lazy"
                  src={BaseURL + data.image}
                />
              </div>
            </div>

            <div className={styles.ProductDetailContainer}>
              <div className="product-detail-body">
                <div className="product-detail-data">
                  <div className={styles.ProductDetailWrapper}>
                    <span className="product-detail-data-title">{data.name}</span>
                  </div>

                  <div className="product-detail-data-price-container">
                    {data.discount_amount ? (
                      <span className="discount-percent">
                        {data.visible_discount_type === 'fixed'
                          ? TComma(data.fixed_discount_amount)
                          : `${data.discount_percentage} %`}
                      </span>
                    ) : null}
                    <div className={styles.UniterWrapper}>
                      {' '}
                      <Uniter className="product-detail-price" unit="تومان">
                        {data.payable_amount}
                      </Uniter>
                      {data.discount_amount !== 0 ? (
                        <Uniter
                          className="product-detail-price  product-price-streak-through"
                          unit="">
                          {data.price}
                        </Uniter>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <div style={{ textAlign: 'center', width: '100%' }}>
                    <Button
                      className="btn-add-to-card"
                      onClick={() => {
                        add_to_cart(data);
                        document.body.style.overflow = 'auto';
                      }}>
                      افزودن به سبد
                    </Button>
                  </div>
                </div>
              </div>

              {/* ----------- مشخصات محصول (product_detail) ------------------ */}
              {product_detail.length > 0 ? (
                <div className={styles.SectionContainer}>
                  <div className="w-100 detail-section-title">
                    <div className="green-small-rectangle" />
                    <div className="detail-section-title-text">مشخصات محصول</div>
                  </div>
                  <Card
                    id="elmt_detailModal_productDetail_section"
                    style={{ padding: '0 10px', marginTop: '5px' }}>
                    {detailItemsValue(product_detail)}
                  </Card>
                </div>
              ) : null}

              {/* -----------جزئیات قیمت (pricing_detail) ------------------ */}
              {pricing_detail.length > 0 ? (
                <div className={styles.SectionContainer}>
                  <div className="w-100 detail-section-title">
                    <div className="green-small-rectangle" />
                    <div className="detail-section-title-text">جزئیات قیمت </div>
                  </div>
                  <Card
                    id="elmt_detailModal_productDetail_section"
                    style={{ padding: '0 20px 0 10px', marginTop: '5px' }}>
                    {detailItemsValue(pricing_detail)}
                  </Card>
                </div>
              ) : null}

              {/* ----------- توضیحات (description) ------------------ */}
              {description.length > 0 ? (
                <div className={styles.SectionContainer}>
                  <div className="w-100 detail-section-title">
                    <div className="green-small-rectangle" />
                    <div className="detail-section-title-text">توضیحات</div>
                  </div>
                  <Card
                    id="elmt_detailModal_productDetail_section"
                    style={{ padding: '0 20px 0 10px', marginTop: '5px' }}>
                    {detailItemsValue(description)}
                  </Card>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default DetailModal;
